import paid from './invoices/paid'
import calendarChannels from './calendars/channels'
import router from './router'
export default [...paid,...calendarChannels, ...router];
